<div class="popupLayout">
   <div class="fullWidth">
      <div class="confirmationText">Are you sure you want to cancel the Request?<span></span></div>
    </div>
    <div class="confirmationButtons">
      <button class="cancelBtn" (click)="closePopup(false)">No</button>
      <button class="deleteBtn" type="submit" (click)="cancelRequest()">{{buttonText}}</button>
    </div>
     
</div>